import { Component, computed, inject } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideArrowLeft, lucideLoaderCircle, lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { SidepanelService } from './sidepanel.service';

@Component({
  selector: 'app-sidepanel-header',
  imports: [HlmButtonImports, HlmIconImports, HlmSpinnerImports, HlmTooltipImports],
  providers: [provideIcons({ lucideX, lucideLoaderCircle, lucideArrowLeft })],
  template: `
    <div class="p-md border-stroke-neutral-light gap-md flex items-center justify-between border-b">
      <div class="gap-md flex items-center">
        @if (hasPreviousSidepanel()) {
          <button (click)="closeMenu()" hlmBtn size="icon" variant="ghost">
            <ng-icon name="lucideArrowLeft" />
          </button>
        }
        <div class="gap-xs flex items-center">
          <ng-content />
        </div>
      </div>
      <div class="flex items-center">
        @if (loadingState()) {
          <hlm-spinner
            class="text-components-content-neutral-secondary"
            icon="lucideLoaderCircle"
            hlmTooltipTrigger="Sauvegarde en cours"
            size="sm"
          />
        }
        @if (sidepanelService.isOpen()) {
          <button (click)="closeMenu()" hlmBtn size="icon" variant="ghost">
            <ng-icon name="lucideX" />
          </button>
        }
      </div>
    </div>
  `,
})
export class SidepanelHeaderComponent {
  readonly sidepanelService = inject(SidepanelService);

  protected readonly loadingState = computed(() => this.sidepanelService.loading());
  protected readonly hasPreviousSidepanel = computed(() => this.sidepanelService.hasPreviousSidepanel());

  closeMenu() {
    this.sidepanelService.close();
  }
}
